import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Header from '@/components/header'
import Footer from '@/components/footer'
import Template from '@/components/template'
import GoogleAnalytics from '@/components/GoogleAnalytics'
import { Toaster } from '@/components/ui/toaster'

// Pages
import Home from '@/pages/Home'
import Galeria from '@/pages/Galeria'
import Events from '@/pages/Events'
import Onbizalom from '@/pages/Onbizalom'
import LelekSzinei from '@/pages/LelekSzinei'
import CsiFestes from '@/pages/CsiFestes'
import Blog from '@/pages/Blog'
import BlogEditor from '@/pages/BlogEditor'
import Utalvany from '@/pages/Utalvany'
import Download2025 from '@/pages/Download2025'
import Page2025 from '@/pages/2025'

// Contact pages
import Contact from '@/pages/Contact'
import ContactAzEnTortenetem from '@/pages/ContactAzEnTortenetem'
import ContactCsiFestes from '@/pages/ContactCsiFestes'
import ContactOnbizalom from '@/pages/ContactOnbizalom'
import ContactSpontan from '@/pages/ContactSpontan'
import ContactUjTavasziCsoport from '@/pages/ContactUjTavasziCsoport'
import ContactSajatUtamon from '@/pages/ContactSajatUtamon'
import ContactHogyVagyMost from '@/pages/ContactHogyVagyMost'
import Husvet2026 from '@/pages/Husvet2026'
import MuveszetNapja from '@/pages/MuveszetNapja'

// Error pages
import ErrorPage from '@/pages/ErrorPage'

export default function App() {
  return (
    <>
      <Helmet>
        <title>BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak" />
        <meta name="keywords" content="művészetterápia, art coaching, családállítás, coaching, önismeret" />
        <meta property="og:title" content="BeArt Művészetterápia" />
        <meta property="og:description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://beart.hu" />
        <meta property="og:image" content="https://beart.hu/images/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="600" />
        <meta property="og:image:alt" content="BeArt Művészetterápia" />
        <meta property="og:site_name" content="BeArt Művészetterápia" />
        <meta property="og:locale" content="hu_HU" />
        <link rel="canonical" href="https://beart.hu" />
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <script
          async
          src="https://js-de.sentry-cdn.com/2c4a16b294b58f39357a439c9f03f392.min.js"
          crossOrigin="anonymous"
        />
      </Helmet>
      
      <GoogleAnalytics />
      
      <div className="relative flex min-h-screen flex-col pb-20">
        <Header />
        <Template>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/events" element={<Events />} />
            <Route path="/onbizalom" element={<Onbizalom />} />
            <Route path="/lelek-szinei" element={<LelekSzinei />} />
            <Route path="/csi-festes" element={<CsiFestes />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/editor" element={<BlogEditor />} />
            <Route path="/utalvany" element={<Utalvany />} />
            <Route path="/2025" element={<Page2025 />} />
            <Route path="/2025/download" element={<Download2025 />} />
            
            {/* Contact routes */}
            <Route path="/kapcsolat" element={<Contact />} />
            <Route path="/kapcsolat/az-en-tortenetem" element={<ContactAzEnTortenetem />} />
            <Route path="/kapcsolat/csi-festes" element={<ContactCsiFestes />} />
            <Route path="/kapcsolat/onbizalom" element={<ContactOnbizalom />} />
            <Route path="/kapcsolat/spontan" element={<ContactSpontan />} />
            <Route path="/kapcsolat/uj-tavaszi-csoport" element={<ContactUjTavasziCsoport />} />
            <Route path="/kapcsolat/sajat-utamon" element={<ContactSajatUtamon />} />
            <Route path="/kapcsolat/hogy-vagy-most" element={<ContactHogyVagyMost />} />

            {/* Easter game (allow trailing slash and subpaths) */}
            <Route path="/husvet2026/*" element={<Husvet2026 />} />
            <Route path="/muveszetnapja/*" element={<MuveszetNapja />} />
            
            {/* Catch all route */}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Template>
        <Footer />
        <Toaster />
      </div>
    </>
  )
}
